import validateFunc from './standaloneValidateCode.js';
export { validateTypes };
function validateTypes(data) {
    validateFunc(data);
    // @ts-expect-error
    return validateFunc.errors || [];
}
//# sourceMappingURL=validateTypes.js.map